export default "__VITE_ASSET__BWC9Bw2v__"